const cleanUid = (raw) => (raw || "").split("&")[0].trim();

export const getUrlParams = () => {
  const url = new URL(window.location.href);

  const pathSegments = window.location.pathname.split("/").filter(Boolean);
  const uidFromPath = cleanUid(pathSegments[pathSegments.length - 1]);

  // read ALL uid values
  const uidList = url.searchParams.getAll("uid");
  const goqiiList = url.searchParams.getAll("goqiiUserId");
  const gidlist= url.searchParams.get("gid");

  // pick FIRST index only
  const encryptedId =
    cleanUid(uidList[0]) ||
    uidFromPath ||
    cleanUid(goqiiList[0]) ||
    "";

  const timestampList = url.searchParams.getAll("timestamp");
  const timestamp = timestampList[0] || "";

  // App sends theme twice: ?theme=null&theme=dark — pick the first valid value
  const themeList = url.searchParams.getAll("theme");
  const validTheme = themeList.find(t => t === "dark" || t === "light");
  const theme = validTheme || "light";

  // Language param: en / ar / hi (default: en)
  const langParam = url.searchParams.get("lang");
  const lang = ["en", "ar", "hi"].includes(langParam) ? langParam : "en";

  // appName param (optional — sent blank if missing)
  const appName = url.searchParams.get("appName") || "";

  return { encryptedId, timestamp, gid:gidlist, theme, lang, appName };
};

export const getGoqiiUserId = () => {
  const search = new URL(window.location.href).searchParams;
  return search.get("goqiiUserId") || search.get("goqiiuserid") || "";
};

export const getAppParams = () => {
  if (typeof window === "undefined") {
    return {};
  }

  const url = new URL(window.location.href);
  const search = url.searchParams;

  const pathSegments = window.location.pathname.split("/").filter(Boolean);
  const uidFromPath = cleanUid(pathSegments[pathSegments.length - 1]);

  return {
    uid: cleanUid(search.get("uid")) || uidFromPath || "",
    goqiiUserId: cleanUid(search.get("goqiiuserid") || search.get("goqiiUserId")) || "",
    gid: search.get("gid") || "",
    goqiiAccessToken: search.get("goqiiAccessToken") || "",
    authToken: search.get("authToken") || "",
    nonce: search.get("nonce") || "",
    apiKey: search.get("apiKey") || "",
    signature: search.get("signature") || "",
    appVersion: search.get("appVersion") || "",
    appType: search.get("appType") || "",
    goqiiAnalyticId: search.get("goqiiAnalyticId") || "",
    deviceIdentifier: search.get("deviceIdentifier") || "",
    OSVersion: search.get("OSVersion") || "",
    goqiiCoachId: search.get("goqiiCoachId") || "",
  };
};